import {Howl, Howler} from "howler";
import * as PIXI from "pixi.js";
import data from "./configs/data";
import {Button} from "./controlElements/Button";
import {CheckBox} from "./controlElements/CheckBox";
import {Dice} from "./Dice";
import {InfoMenu} from "./InfoMenu";

export class Menu extends PIXI.Container {

    private volumeCheckBox: CheckBox;
    private infoButton: Button;
    private menuButton: Button;

    private readonly VOLUME_CHECKBOX_POSITION = new PIXI.Point(124, 0);
    private readonly INFO_BUTTON_POSITION = new PIXI.Point(62, 0);

    private LOCAL_STORAGE_SOUND_ENABLED_KEY = "soundEnabled";

    constructor() {
        super();

        this.createAndAddMenuButton();
        this.createVolumeCheckbox();
        this.createInfoButton();
        this.close();
        if (localStorage.getItem(this.LOCAL_STORAGE_SOUND_ENABLED_KEY) === "false") {
            this.volumeCheckBox.checked = false;
            Howler.volume(0.0);
        }
    }

    public close(): void {
        this.volumeCheckBox.visible = false;
        this.infoButton.visible = false;
    }

    public toggle(): void {
        this.volumeCheckBox.visible = !this.volumeCheckBox.visible;
        this.infoButton.visible = !this.infoButton.visible;
    }

    private createAndAddMenuButton(): void {
        this.menuButton = new Button(data.images.menuButtonBase, data.images.menuButtonHover,
            data.images.menuButtonClick, data.images.menuButtonBase, data.audios.buttonClicked);
        this.menuButton.scale = Dice.ELEMENTS_SCALE;
        this.addChild(this.menuButton);
        this.menuButton.subscribeOnClicked(() => {
            this.toggle();
        });
    }

    private createVolumeCheckbox(): void {
        this.volumeCheckBox = new CheckBox(data.images.volumeOffBase, data.images.volumeOffHover,
            data.images.volumeOffClick, data.images.volumeOffClick, data.images.volumeOnBase,
            data.images.volumeOnHover, data.images.volumeOnClick,
            data.images.volumeOnClick, data.audios.buttonClicked);
        this.volumeCheckBox.checked = true;
        this.volumeCheckBox.position = this.VOLUME_CHECKBOX_POSITION;
        this.addChild(this.volumeCheckBox);
        this.volumeCheckBox.scale = Dice.ELEMENTS_SCALE;
        this.volumeCheckBox.subscribeOnClicked((isChecked) => {
            if (isChecked) {
                localStorage.setItem(this.LOCAL_STORAGE_SOUND_ENABLED_KEY, "true");
                Howler.volume(1.0);
            } else {
                localStorage.setItem(this.LOCAL_STORAGE_SOUND_ENABLED_KEY, "false");
                Howler.volume(0.0);
            }
        });
    }

    private createInfoButton(): void {
        this.infoButton = new Button(data.images.infoBase, data.images.infoHover, data.images.infoClick,
            data.images.infoClick, data.audios.buttonClicked);
        this.infoButton.position = this.INFO_BUTTON_POSITION;
        this.infoButton.scale = Dice.ELEMENTS_SCALE;
        this.addChild(this.infoButton);
        this.infoButton.subscribeOnClicked(() => {
            InfoMenu.getInstance().toggleVisibility();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/Menu.ts